var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"vs-link-cta vs-reset-form",attrs:{"type":"button"},on:{"click":_vm.resetForm}},[_vm._v(" "+_vm._s(_vm.resetLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }